import { paths } from "helpers/paths";
import { useMemo } from "react";
import { useHistory, useLocation, useParams, useRouteMatch } from "react-router-dom";

function getParams(search: string) {
    const urlSearchParams = new URLSearchParams(search);
    return Object.fromEntries(urlSearchParams.entries());
}

export function useRouter() {
    const params = useParams();
    const location = useLocation();
    const history = useHistory();
    const match = useRouteMatch();
    return useMemo(() => {
        return {
            push: history.push,
            replace: history.replace,
            pathname: location.pathname,
            query: {
                ...getParams(location.search),
                ...params,
            } as { [key: string]: string },
            match,
            location,
            history,
            paths,
        };
    }, [params, match, location, history]);
}
